export default {
  // FrontPage.vue
  frontPageRequirementTitle: 'Punya',
  frontPageProvideTitle: 'Nawarkan',
  frontPagePersonalCenterTitle: 'Profil',
  login: 'Masuk',
  home_chatWithOctopie: 'Memahami pikiranmu',
  home_chatNeedUnderstood: 'Pikiranmu sudah dipahami',
  home_draftBannerTitle: 'Selesaikan pesanmu',
  home_draftBannerSubtitle: 'AI sudah menyiapkan pesanmu — ketuk untuk melanjutkan',
  home_tabHome: 'Beranda',

  // App.vue
  appRequirementTitle: 'Kami menghargai setiap saran dan masukan',
  appRequirementBtn: 'Kirim',
  appSubmitSuccess: 'Berhasil dikirim, terima kasih atas masukanmu',
  appFeedbackLink: 'Saran/Masukan',
  mobile_banner_text: 'Untuk pengalaman terbaik, gunakan aplikasi kami',
  mobile_banner_btn: 'Dapatkan Aplikasi',

  // Common
  loading: 'Memuat...',
  confirm: 'Konfirmasi',
  cancel: 'Batal',
  save: 'Simpan',
  delete: 'Hapus',
  edit: 'Edit',
  add: 'Tambah',
  search: 'Cari',
  refresh: 'Muat ulang',
  change_batch: 'Acak',
  back: 'Kembali',
  submit: 'Kirim',
  close: 'Tutup',
  ok: 'OK',
  yes: 'Ya',
  no: 'Tidak',
  send: 'Kirim',
  block: 'Blokir',
  more: 'Lainnya',
  logout: 'Keluar',
  settings: 'Pengaturan',
  view_guide: 'Lihat Panduan',
  feedback: 'Umpan Balik',
  feedback_title: 'Umpan Balik',
  feedback_new: 'Umpan Balik Baru',
  feedback_empty: 'Belum ada umpan balik',
  feedback_hint: 'Sampaikan pendapatmu...',
  feedback_submit: 'Kirim',
  feedback_submit_success: 'Umpan balik berhasil dikirim',
  feedback_submit_failed: 'Gagal mengirim umpan balik',
  feedback_reply_label: 'Balasan Platform',
  register: 'Daftar',
  name: 'Nama',
  email: 'Email',
  mobile: 'Ponsel',
  password: 'Kata sandi',
  verification_code: 'Kode verifikasi',
  company_name: 'Beijing Liangshao Technology Co., Ltd.',
  all_rights_reserved: 'Hak cipta dilindungi.',
  footerVersion: 'Versi {version}',
  copy: 'Salin',
  regenerate: 'Buat ulang',
  generate: 'Buat',
  contact_now: 'Chat',
  yours: 'kamu',
  xiaoyao_analysis: 'Analisis AI',
  brand_name: 'OctoSay',
  anonymous: 'Anonim',
  no_summary: 'Tanpa ringkasan',
  file: 'File',
  discover: 'Jelajah',
  discover_title: 'Jelajah',
  discover_hotChannels: 'Channel Populer',
  discover_allChannels: 'Semua',
  discover_searchChannel: 'Cari channel',
  discover_noChannels: 'Tidak ada channel ditemukan',

  // Messages
  operationSuccess: 'Operasi berhasil',
  operationFailed: 'Operasi gagal',
  networkError: 'Kesalahan jaringan, coba lagi nanti',
  dataLoadingFailed: 'Gagal memuat data',
  noData: 'Tidak ada data',
  deleteConfirm: 'Yakin ingin menghapus?',
  saveConfirm: 'Yakin ingin menyimpan?',

  // Form Validation
  required: 'Kolom ini wajib diisi',
  emailInvalid: 'Masukkan alamat email yang valid',
  phoneInvalid: 'Masukkan nomor telepon yang valid',
  passwordTooShort: 'Kata sandi minimal {min} karakter',
  passwordMismatch: 'Kata sandi tidak cocok',

  // Time
  today: 'Hari ini',
  yesterday: 'Kemarin',
  justNow: 'Baru saja',
  minutesAgo: '{min} menit lalu',
  hoursAgo: '{hour} jam lalu',
  daysAgo: '{day} hari lalu',

  // Footer
  about: 'Tentang',
  footerPrivacy: 'Kebijakan Privasi',
  footerTerms: 'Ketentuan Layanan',
  footerSupport: 'Dukungan',

  // Register
  registerAgeConfirm: 'Saya konfirmasi bahwa saya berusia minimal 13 tahun',
  registerAgeConfirm18: 'Saya konfirmasi bahwa saya berusia minimal 18 tahun',
  registerTermsPrefix: 'Saya sudah membaca dan menyetujui ',
  registerTermsAnd: ' dan ',
  registerAgeError: 'Konfirmasi usiamu',
  registerTermsError: 'Setujui ketentuan dan kebijakan privasi',

  // Chat
  chatPrivacyTip: 'Ketik pesanmu di hub dan AI akan mengobrol dulu untuk memperjelas. Setelah kamu konfirmasi, pesan dan ringkasan AI diposting bersamaan dan AI terus mencarikan match.',
  aiChat_quickSuggestions: 'Coba bilang',
  aiChat_welcome: "Hai! Ceritakan apa yang kamu cari.",

  // Chat - AI Progress Steps (new)
  aiChat_readyToPost: 'Detail sudah dipahami — posting untuk menemukan matchmu',
  aiChat_readyToPostHint: 'Lanjutkan mengobrol untuk menambah detail atau memperbarui ringkasan kapan saja',
  aiChat_progressStep1: 'Pahami detail',
  aiChat_progressStep1Done: 'Detail sudah dipahami',
  aiChat_progressStep2: 'Ringkasan AI',
  aiChat_progressStep2Desc: 'AI membuat ringkasan untuk matching',
  aiChat_progressStep3: 'Posting ke Grup',
  aiChat_progressStep3Desc: 'Posting dan temukan matchmu',
  aiChat_publishExtraHint: 'Masukkan pesanmu untuk hub',
  aiChat_publishMsgRequired: 'Wajib',
  aiChat_publishMsgLabel: 'Pesanmu untuk hub',
  aiChat_matchSummaryLabel: 'Ringkasan AI',

  ai_generated_label: 'AI Generated',

  ai_content_disclaimer: 'Konten berikut dihasilkan oleh AI dan hanya untuk referensi.',
  aiChat_publishSuggestionHint: 'Ketuk untuk mengganti',
  aiChat_allowDirectContact: 'Izinkan kontak langsung',
  aiChat_allowDirectContactDesc: 'Orang lain bisa menghubungimu langsung tanpa harus match',
  channel_chat_session_publishToChannel: 'Posting ke Grup Octo',
  aiChat_newChat: 'Reset',

  // Channels / Grup
  home_tabChannels: 'Grup Octo',
  channels_title: 'Grup Octo',
  channels_myChannels: 'Grup yang Diikuti',
  channels_discover: 'Jelajah',
  channels_noChannels: 'Belum ada hub',
  channels_noMyGroupsTitle: 'Kamu belum bergabung ke hub mana pun',
  channels_noMyGroupsSubtitle: 'Cari hub untuk bergabung dan mulai terhubung',
  channels_searchGroupsBtn: 'Cari Grup',
  channels_loginPrompt: 'Masuk untuk melihat hub',
  channels_create: 'Buat Grup Octo',
  channels_search: 'Cari Grup Octo',
  channels_searchMyGroups: 'Cari Grup Octo saya',
  channels_searchHint: 'Cari',
  channels_searchHintChats: 'Cari obrolan...',
  channels_searchHintGroups: 'Cari hub...',
  channels_searchHintMy: 'Cari hub yang diikuti...',
  channels_joinByCode: 'Gabung dengan Kode',
  channels_joinByCodeTitle: 'Gabung ke Grup Octo dengan Kode',
  channels_joinByCodeHint: 'Masukkan kode Grup Octo',
  channels_joinByCodeConfirm: 'Gabung',
  channels_joinByCodeNotFound: 'Grup tidak ditemukan',
  channels_createNewGroup: 'Buat Grup Octo baru',
  channels_noResults: 'Tidak ada hub ditemukan',
  channel_detail_join: 'Gabung',
  channel_detail_leave: 'Keluar',
  channel_detail_members: 'anggota',
  // 聚合进群消息 banner（joinMsgs）
  channelJoinMsg_oneJoined: '{name} bergabung ke hub',
  channelJoinMsg_twoJoined: '{name1} dan {name2} bergabung ke hub',
  channelJoinMsg_multiJoined: '{name1}, {name2} dan {n} lainnya bergabung ke hub',
  channelJoinMsg_oneAndMoreJoined: '{name} dan {n} lainnya bergabung ke hub',
  channelJoinMsg_membersJoined: '{n} anggota bergabung ke hub',

  // Feed
  channels_feed: 'Obrolan',
  channels_groups: 'Grup',
  feed_related: 'Terkait',
  feed_recommend: 'Rekomendasi',
  feed_empty: 'Belum ada feed, jelajahi hub populer',
  feed_goToGroup: 'Lihat di hub',
  feed_joinGroupAndSendMsg: 'Gabung ke hub dan kirim pesan',
  channel_detail_channelCode: 'Kode Grup Octo',
  channel_detail_invitePhrase: 'Undangan bergabung dengan "{name}"\nKode undangan {code} — buka aplikasi untuk bergabung otomatis · AI memperjelas dulu, lalu menemukan orang yang tepat',
  channel_detail_post: 'Posting ke Grup',
  channel_detail_aiHint: "Ketik pesanmu di hub dan AI akan memperjelas detailnya dulu",
  channel_input_hint: 'Katakan sesuatu...',
  channel_leave_confirm_message: 'Yakin ingin keluar dari hub ini? Kamu tidak akan lagi menerima pesan hub.',
  channel_invite_notFound: 'Grup tidak ditemukan atau tautan sudah kedaluwarsa',
  channel_invite_joinBtn: 'Unduh Aplikasi OctoSay',
  channel_invite_hint: 'Unduh aplikasinya, lalu pindai kode QR ini atau cari nama hub untuk bergabung',
  channel_invite_globalHintTitle: 'Kamu akan mengunduh versi Global',
  channel_invite_globalHintIOS: 'Aplikasi ini mungkin tidak tersedia di App Store Tiongkok. Beralihlah ke Apple Store di luar Tiongkok dan cari OctoSay, atau unduh APK langsung di bawah.',
  channel_invite_globalHintAndroid: 'Google Play mungkin tidak dapat diakses di wilayahmu. Kami sarankan mengunduh APK langsung, atau coba Google Play.',
  channel_invite_globalHintDefault: 'Aplikasi mungkin tidak tersedia di app store lokal. Kami sarankan mengunduh APK langsung, atau coba App Store.',
  channel_invite_globalBtnAppStore: 'Buka App Store',
  channel_invite_globalBtnGooglePlay: 'Buka Google Play',
  channel_invite_globalBtnAPK: 'Unduh APK Langsung',
  channel_invite_defaultDesc: 'Gabung ke {name} di OctoSay',
  share: 'Bagikan',
  share_channel: 'Bagikan Grup',
  share_channel_link: 'Bagikan Tautan',
  channel_detail_inviteCode: 'Kode Undangan',
  channel_detail_copyLink: 'Salin Tautan',
  share_session_title: 'Sebuah postingan di OctoSay',
  share_match_title: 'Sebuah match di OctoSay',
  share_session_text: '{userName}: {summary}',
  share_session_text_no_summary: 'Lihat postingan {userName} di OctoSay',
  session_share_notFound: 'Postingan tidak ditemukan atau tautan sudah kedaluwarsa',
  session_share_fromChannel: 'Dari Grup Octo',
  session_share_downloadBtn: 'Unduh Aplikasi OctoSay',
  session_share_hint: 'Unduh aplikasinya untuk melihat postingan lengkap dan bergabung ke hub',
  session_share_openInApp: 'Buka di Aplikasi',
  toast_link_copied: 'Tautan tersalin',
  toast_no_share_data: 'Tidak ada yang bisa dibagikan',
  channels_joinByQR: 'Kode QR',
  channels_joinByQRWebHint: 'Web tidak mendukung pemindaian QR. Masukkan kode hub untuk bergabung.',
  channels_joinByQRTitle: 'Gabung dengan Kode QR',
  channel_detail_qrCode: 'Kode QR',
  channel_detail_qrCodeSave: 'Simpan Gambar',
  channel_detail_qrCodeSaveHint: 'Klik kanan gambar untuk menyimpan',
  channel_detail_qrCodeSaved: 'Tersimpan ke album',
  channel_detail_qrCodeSaveFailed: 'Gagal menyimpan, coba lagi',
  channel_detail_locateFailed: 'Gagal menemukan lokasi pesan',
  channel_detail_locateError: 'Gagal menemukan lokasi pesan',
  channel_detail_myMessages: 'Pesan Saya',
  channel_detail_searchMessages: 'Cari Pesan',
  channel_detail_aiChat: 'Obrolan AI',
  channel_detail_matchHistory: 'Riwayat Match',
  channel_create_title: 'Buat Grup Octo',
  channel_create_name: 'Nama Grup Octo',
  channel_create_description: 'Deskripsi',
  channel_create_submit: 'Buat',
  channelCreate_aiAssist: 'AI akan membantumu membuat hub yang sesuai',
  channelCreate_nameHint: 'Masukkan nama untuk hub-mu',
  channelCreate_descHint: 'Jelaskan tentang apa hub-mu',
  channelCreate_creating: 'Membuat...',
  channelCreate_created: 'Grup dibuat!',
  channelCreate_failed: 'Gagal membuat hub',
  channelCreate_welcomeMsg: "Hai! Aku di sini untuk membantumu membuat hub. Ceritakan hub seperti apa yang kamu inginkan — namanya, topiknya, atau tujuannya — dan akan kubantu jadikan nama hub dan pengantar hub, sekaligus membuat foto profil.",
  channelCreate_aiHint: 'Tulis topik hub-mu...',
  channelCreate_clarifyingProgress: 'Menyusun topik hub-mu...',
  channelCreate_readyToCreate: 'Siap membuat Grup Octo',
  channelCreate_step1: 'Jelaskan Topik',
  channelCreate_step1Done: 'Ide sudah jelas',
  channelCreate_step2: 'Buat Grup Octo',
  channelCreate_confirmBtn: 'Konfirmasi Pembuatan',
  channelCreate_publicNotice: 'Grup adalah ruang publik bagi orang-orang dengan minat serupa untuk berkumpul dan terhubung. Platform dapat mengelola, memperbarui, atau menggabungkan hub sesuai kebutuhan. Silakan bagikan hub ini kepada orang lain yang mungkin tertarik.',
  channelCreate_similarGroupsTitle: 'Grup Octo Serupa Ditemukan',
  channelCreate_similarGroupsDesc: 'Grup-hub ini mungkin sesuai dengan yang kamu mau',
  channelCreate_exactMatchHint: 'Grup dengan nama yang sama persis sudah ada!',
  channelCreate_joinHint: 'Grup yang sudah ada ini mungkin cocok',
  channelCreate_joinExisting: 'Gabung ke Grup Octo yang Ada',
  channelCreate_stillCreate: 'Tetap Buat Grup Octo Baru',
  channel_chat_session_comments: 'Komentar',
  channel_chat_session_commentHint: 'Tulis komentar...',
  channel_chat_session_sendComment: 'Komentar',
  channel_chat_session_loadMore: 'Muat lebih banyak',
  channel_chat_session_noComments: 'Belum ada komentar',
  channel_chat_session_deleteComment: 'Hapus',
  channelSearch_title: 'Cari di Grup',
  channelSearch_placeholder: 'Cari pesan...',
  channelSearch_onlyMine: 'Hanya postinganku',
  channelSearch_tabAllMessages: 'Pesan Grup',
  channelSearch_tabMyMessages: 'Pesan Saya',
  chatMsgSearch_placeholder: 'Cari pesan',
  chatMsgSearch_tabMsgs: 'Pesan',
  chatMsgSearch_tabContacts: 'Kontak',
  chatMsgSearch_emptyPrompt: 'Ketik kata kunci untuk mencari pesan',
  chatMsgSearch_tooShort: 'Ketik minimal 2 karakter untuk mencari',
  chatMsgSearch_contactEmptyPrompt: 'Ketik nama pengguna atau email untuk mencari kontak',
  chatMsgSearch_noContacts: 'Tidak ada kontak yang cocok',
  chatMsgSearch_inChatPlaceholder: 'Cari di obrolan ini',
  channelHistory_title: 'Riwayat',
  channelHistory_myMessages: 'Pesan Saya',
  channelHistory_loadMore: 'Muat lebih banyak',
  channel_settings_push: 'Notifikasi Grup Octo',
  channel_settings_commentPush: 'Notifikasi Komentar',
  channel_settings_likePush: 'Notifikasi Suka',
  channel_settings_receiveNotifications: 'Terima Notifikasi',
  channel_settings_directContact: 'Izinkan Kontak Langsung',
  session_published: 'Dipublikasikan',
  session_publishFailed: 'Gagal mempublikasikan',
  session_setDirectContactSuccess: 'Pengaturan tersimpan',
  session_setDirectContactFailed: 'Gagal menyimpan pengaturan',
  session_setPrivate: 'Jadikan Privat',
  session_setPublic: 'Jadikan Publik',
  session_pauseMatching: 'Jeda pencocokan',
  session_resumeMatching: 'Lanjutkan pencocokan',
  session_matchPausedToast: 'Pencocokan dijeda',
  session_matchResumedToast: 'Pencocokan dilanjutkan',
  match_matchingPausedTitle: 'Pencocokan dijeda',
  match_reasonTag: 'Alasan pencocokan',
  match_matchingPausedHint: 'Lanjutkan pencocokan kapan saja.',
  session_confirmSetPrivate: 'Jadikan konten ini privat? Pengguna lain tidak akan bisa melihatnya.',
  session_messageIsPrivate: 'Pesan ini privat',
  chatSessionComment_replyHint: 'Tulis komentar...',
  chatSessionComment_reply: 'Komentar',
  chatSessionComment_count: '{n} komentar',
  chatSessionMatch_count: '{n} match',
  chatSessionComment_replyTo: 'Balas',
  chatSessionComment_inputHint: 'Tulis komentar...',
  chatSessionComment_send: 'Kirim',
  chatSessionComment_delete: 'Hapus',
  chatSessionComment_deleteConfirm: 'Yakin ingin menghapus komentar ini?',
  chatSessionComment_loadMore: 'Muat lebih banyak',
  chatSessionComment_noMore: 'Tidak ada komentar lagi',
  chatSessionComment_loginToComment: 'Masuk untuk berkomentar',
  chatSessionComment_viewEarlier: 'Lihat {n} balasan sebelumnya',
  chatSessionLike_like: 'Suka',
  chatSessionLike_liked: 'Disukai',
  chatSessionLike_count: 'suka',
  chatSessionBookmark_bookmark: 'Simpan',
  chatSessionBookmark_bookmarked: 'Tersimpan',
  chatSessionMatch_viewMatches: 'Lihat Match',
  chatSessionMatch_matchHistory: 'Riwayat Match',
  chatSessionMatch_noMatches: 'Belum ada match',
  channel_match_achievement: '{count} postingan berhasil dipasangkan',
  channel_match_achievement_view: 'Lihat →',
  channel_matchHistory_title: 'Riwayat Match Channel',
  chatSessionMatch_matchedAt: 'Match pada {time}',
  discover_userMsgLabel: 'Pengguna berkata',
  common_loading: 'Memuat...',
  common_sending: 'Mengirim...',
  common_error: 'Kesalahan',
  common_success: 'Berhasil',
  common_me: 'Saya',

  // Chat - Set Public / Pick Location
  aiChat_clarifyingProgress: "AI sedang memperjelas kebutuhanmu agar setiap pesan yang diposting berfungsi; setelah diposting, AI terus mencarikanmu match",
  aiChat_clarifyingAlmostDone: 'Hampir selesai, silakan konfirmasi',
  aiChat_clarifyingOneMore: 'Tinggal sekitar 1 pertanyaan lagi, lalu kamu bisa posting',
  aiChat_clarifyingRemaining: 'Sekitar {count} ronde lagi, hampir selesai',
  aiChat_clarifyingEvaluating: 'Menilai progres...',
  aiChat_setPublicMatch: 'Jadikan Publik & Match',
  aiChat_needsClarifiedPublic: "Aku paham sekarang. Setelah kamu konfirmasi dan posting, AI akan terus mencarikan match.\nSilakan bagikan detail lebih kapan saja.",
  aiChat_needsClarifiedPrivate: 'Oke, paham! Jadikan publik biar aku terus mencarikan match!\nSilakan ceritakan detail lebih kapan saja.',
  aiChat_setPublicTitle: 'Jadikan Publik',
  aiChat_setPublicMessage: 'Kontenmu akan terlihat oleh orang lain agar OctoSay dapat menemukan match yang melengkapi.\n\nInformasi yang akan dibagikan:\n• Nama pengguna dan avatarmu\n• Ringkasan kontenmu\n• Isi percakapan (terlihat di Jelajah)\n\nKamu bisa mengembalikannya menjadi privat kapan saja.',
  aiChat_findMatches: 'Lihat Hasil Match',
  aiChat_publishing: 'Sedang memposting...',
  aiChat_matchSectionTitle: 'Pesanmu paling cocok untuk grup-grup ini — ketuk untuk posting',
  aiChat_joinedBadge: 'Bergabung',
  aiChat_matchSectionEmpty: 'Belum ada grup yang cocok — kamu bisa membuat grup baru dan memposting di sana',
  aiChat_suggestPublishCreateNew: 'Buat grup baru',
  aiChat_repickChannel: 'Ganti grup',
  aiChat_creatingChannelTitle: 'Tidak ada grup yang cocok — membuatkan untukmu',
  aiChat_creatingChannelHint: 'AI sedang membuat grup sesuai permintaanmu, setelah itu langsung posting — biasanya 10-30 detik',
  aiChat_publishToChannelHint: 'Akan diposting ke "{name}"',
  aiChat_pickChannelTitle: 'Pilih grup untuk posting',
  aiChat_matchingChannelTitle: 'Mencari grup yang tepat untukmu',
  aiChat_matchingChannelHint: 'AI sedang mencari berdasarkan permintaanmu — biasanya beberapa detik sampai setengah menit',
  aiChat_matchUnavailableTitle: 'Rekomendasi tidak tersedia',
  aiChat_matchUnavailableHint: 'Cari grup di bawah, atau tutup dan buka lagi halaman posting',
  aiChat_waitSlowHint: 'Lebih lambat dari biasanya, tapi masih diproses — tunggu sebentar lagi, atau cari grup di bawah',
  aiChat_creatingSlowHint: 'Pembuatan grup lebih lambat dari biasanya, tapi masih diproses — setelah ini langsung posting',
  aiChat_pickChannelEmptyHint: 'Tidak menemukan grup yang relevan. Buat grup baru untuk memposting pesanmu',
  aiChat_loadMore: 'Muat Lebih Banyak',
  sidebar_publish: 'Posting',
  chat_selectLocationOnMap: 'Pilih lokasi di peta',

  // App.vue new
  placeholder_email: 'Masukkan email',
  placeholder_mobile: 'Masukkan nomor ponsel',
  placeholder_password: 'Masukkan kata sandi',
  placeholder_name: 'Masukkan namamu',
  random_nickname: 'Acak',
  placeholder_verification_code: 'Masukkan kode verifikasi',
  sending: 'Mengirim...',
  registering: 'Mendaftar...',
  send_code: 'Kirim Kode',
  retry_in_seconds: 'Coba lagi dalam {countdown}s',
  toast_enter_email: 'Masukkan email',
  toast_enter_mobile: 'Masukkan nomor ponsel',
  toast_invalid_email: 'Masukkan format email yang valid',
  toast_invalid_mobile: 'Masukkan nomor ponsel yang valid',
  toast_send_code_failed: 'Gagal mengirim kode verifikasi',
  toast_code_sent: 'Kode verifikasi dikirim ke email',
  toast_code_sent_sms: 'Kode verifikasi dikirim ke ponsel',
  toast_send_code_error: 'Gagal mengirim kode verifikasi, coba lagi nanti',
  toast_fill_all_fields: 'Isi semua kolom',
  toast_login_failed: 'Gagal masuk',
  toast_login_success: 'Berhasil masuk',
  oauthOr: 'atau',
  toast_oauth_login_failed: 'Login Google gagal',
  toast_oauth_login_error: 'Kesalahan login Google, coba lagi',
  toast_login_error: 'Gagal masuk, coba lagi nanti',
  toast_register_failed: 'Gagal mendaftar',
  toast_register_success: 'Berhasil mendaftar',
  toast_register_error: 'Gagal mendaftar, coba lagi nanti',

  // AdBanner.vue
  ad: 'Iklan',

  // ContactAdGate.vue 联系前广告闸门
  contactAd_gateTitle: 'Sebelum terhubung',
  contactAd_gateSubtitle: 'Jeda singkat ini membuat OctoSay tetap gratis — terima kasih atas dukungannya!',
  contactAd_waitBtn: 'Lanjut dalam {sec} dtk',
  contactAd_continueBtn: 'Lanjutkan ke obrolan',

  // ChannelDetail.vue 私聊按钮
  session_privateChat: 'Obrolan',

  // AiMatch.vue
  ai_welcome_msg: 'Hai, aku AI. Ceritakan apa yang ada di pikiranmu — cari teman, partner, tukar keahlian, atau APAPUN itu.',
  default_username: 'Pengguna',

  // AvatarCropDialog.vue
  crop_hint: 'Cubit untuk zoom, geser untuk menyesuaikan',
  toast_crop_failed: 'Gagal memotong gambar',

  // ChatBox.vue
  loading_match_info: 'Memuat info match...',
  view_match_details: 'Lihat detail match',
  step_clarify_needs: 'Perjelas',
  step_ai_matching: 'Posting ke Grup',
  step_connect: 'Match AI',
  make_private: 'Jadikan Privat',
  setting: 'Menyetel...',
  action_photo: 'Foto',
  action_file: 'File',
  action_video: 'Video',
  action_location: 'Lokasi',
  hint_get_app: 'Dapatkan aplikasinya agar tetap terhubung',
  match_finding_title: 'Match Kamu',
  match_finding_subtitle: 'AI terus mencarikan match untukmu',
  match_time_hint: 'Proses ini biasanya memakan waktu 1-2 menit',
  match_result_stats: 'Menemukan {matched} match terbaik{interested}',
  match_tap_to_connect: 'Ketuk untuk memulai percakapanmu',
  match_channel_hint: 'Mencocokkan di hub <strong>#{channel}</strong>. Prioritas match dalam hub yang sama, tapi bisa termasuk hub lain bila diperlukan.',
  label_perfect_match: 'Match Terbaik',
  label_worth_a_look: 'Layak Dilihat',
  match_no_result_title: 'Masih mencarikan match untukmu',
  match_no_result_desc: 'Bagikan lebih banyak detail untuk membantu OctoSay menemukan match yang tepat. Pasang aplikasinya untuk menerima notifikasi saat ada yang match denganmu.',
  go_back: 'Kembali',
  no_public_requirements: 'Belum ada postingan publik',
  channelEmpty_title: 'Masih sepi di sini',
  channelEmpty_subtitle: 'Jadilah yang pertama membagikan gagasan',
  channelEmpty_hint: "Tuliskan idemu dan AI akan membantumu memperjelas serta terus mencocokkan, agar pesanmu tidak tenggelam",
  channelEmpty_action: 'Bagikan gagasanmu',
  stay_connected: 'Tetap Terhubung',
  download_app_desc: 'Dapatkan Aplikasinya untuk mengobrol dan langsung menerima notifikasi saat ada yang menghubungimu!',
  app_store: 'App Store',
  google_play: 'Google Play',
  direct_apk: 'APK Langsung',
  match_history: 'Riwayat Match',
  no_match_history: 'Belum ada riwayat match',
  finding_matches: 'AI terus mencarikan match - Setelah posting pesan ke hub',
  discover_connect_hint: 'Kamu bisa mengobrol setelah match!',
  match_initializing: 'Inisialisasi...',
  placeholder_login_to_chat: 'masuk untuk bercerita apa yang ada di pikiranmu',
  toast_need_clear: 'Ide kamu sudah jelas!',
  toast_ai_responding: 'AI sedang menjawab, mohon tunggu...',
  toast_uploading_image: 'Mengunggah gambar, mohon tunggu...',
  toast_uploading_file: 'Mengunggah file, mohon tunggu...',
  toast_max_photos: 'Maksimal {max} foto',
  toast_uploading: 'Mengunggah, mohon tunggu...',
  toast_file_too_large: '{name} melebihi batas 5MB',
  toast_video_too_large: '{name} melebihi batas 20MB',
  toast_video_processing: 'Video sedang diproses, mohon tunggu...',
  toast_upload_link_failed: 'Gagal mendapatkan tautan unggah',
  analyzing_image: 'Menganalisis gambar...',
  toast_location_confirmed: 'Lokasi dikonfirmasi',
  toast_location_selected: 'Lokasi dipilih',
  toast_enter_search: 'Masukkan kata yang ingin dicari',
  toast_search_failed: 'Pencarian gagal',
  toast_no_locations: 'Tidak ada lokasi ditemukan',
  toast_search_error: 'Pencarian gagal, coba lagi',
  toast_located_at: 'Ditemukan di: {address}',
  toast_shared_finding: 'Dibagikan! Mencari match...',
  toast_update_failed: 'Gagal memperbarui',
  toast_set_private: 'Diatur menjadi privat',
  toast_no_matches: 'Tidak ada match ditemukan',
  toast_matches_found: 'Menemukan {count} match terbaik',
  toast_start_conversation_first: 'Mulai percakapan dulu ya',
  toast_load_history_failed: 'Gagal memuat riwayat match',
  toast_ai_timeout: 'AI kehabisan waktu, coba lagi',
  toast_message_blocked: 'Pesan diblokir',
  network_disconnected: 'Jaringan terputus',
  toast_publish_success: 'Terposting ke hub!',
  toast_publish_failed: 'Gagal posting ke hub',

  // ChatMsgList.vue
  collapse_thinking: 'tutup proses berpikir',
  expand_thinking: 'buka proses berpikir',
  thinking: 'berpikir',
  select_date: 'Pilih Tanggal',
  selected_location: 'Lokasi Terpilih',
  msg_blocked: 'Diblokir',
  retry: 'Coba Lagi',
  msg_read: 'Dibaca',
  msg_sent: 'Terkirim',
  msg_unread: 'Belum dibaca',
  label_start_datetime: 'Tanggal & Waktu Mulai:',
  label_end_datetime: 'Tanggal & Waktu Selesai:',
  toast_select_start_datetime: 'Pilih tanggal dan waktu mulai',
  toast_end_before_start: 'Tanggal dan waktu selesai tidak boleh lebih awal dari waktu mulai',
  report_message: 'Laporkan Pesan',
  block_user: 'Blokir Pengguna',
  msg_revoke: 'Tarik',
  msg_quote: 'Kutip',
  msg_revoked_self: 'Kamu menarik sebuah pesan',
  msg_revoked_other: 'Pihak lain menarik sebuah pesan',
  // Neutral text inside quote block: the revoker is the sender of the quoted message, unrelated to current message direction
  msg_revoked_generic: 'Pesan ditarik',
  // Platform removal (content moderation manual review), distinct from self-revoke
  msg_revoked_platform: 'Pesan ini telah ditarik oleh platform karena melanggar ketentuan',
  msg_blocked_label: 'This message was blocked by the platform',
  toast_revoke_success: 'Pesan ditarik',
  toast_revoke_failed: 'Gagal menarik pesan',
  toast_load_data_failed: 'Gagal memuat data, silakan muat ulang.',
  toast_file_url_missing: 'URL file tidak ditemukan',
  toast_block_success: 'Pengguna berhasil diblokir',
  toast_block_failed: 'Gagal memblokir pengguna',

  // ChatSession.vue
  no_more_records: 'tidak ada catatan lagi.',
  title_needs_clarified: 'Pikiran Diperjelas',
  title_clarifying: 'Memperjelas Pikiranmu',
  title_public: 'Publik',
  title_private: 'Privat',
  badge_clarified: 'Terperjelas',
  badge_clarifying: 'Memperjelas',
  badge_only_me: 'Hanya Saya',
  badge_expired: 'Kedaluwarsa',
  title_expired: 'Kedaluwarsa',
  no_chat_history: 'Belum ada riwayat obrolan',

  // ContactMethods.vue
  block_status_banner: 'Kamu telah memblokir pengguna ini',
  unblock_user: 'Buka Blokir',
  toast_block_missing_id: 'Tidak bisa memblokir: ID pengguna hilang',
  dialog_block_confirm: 'Yakin ingin memblokir {name}? Kamu tidak akan menerima pesan apa pun darinya.',
  toast_user_blocked: '{name} telah diblokir',
  toast_unblock_missing_id: 'Tidak bisa membuka blokir: ID pengguna hilang',
  toast_user_unblocked: '{name} telah dibuka blokirnya',

  // BlockedUsers.vue
  blocked_users: 'Pengguna Diblokir',
  blocked_users_empty: 'Belum ada pengguna yang diblokir',
  blocked_users_empty_hint: 'Pengguna yang diblokir tidak akan bisa mengirim pesan kepadamu',
  blocked_users_unblock: 'Buka Blokir',
  dialog_unblock_confirm: 'Setelah dibuka, dia akan bisa mengirim pesan kepadamu lagi.',
  toast_unblock_success: 'Blokir dibuka',
  toast_unblock_failed: 'Gagal membuka blokir, coba lagi',
  blocked_users_load_failed: 'Gagal memuat. Ketuk untuk coba lagi',
  blocked_users_blocked_at: 'Diblokir {date}',
  blocked_users_unknown_user: 'Pengguna tidak dikenal',

  // Contacts.vue
  no_connections: 'Belum ada pesan',
  chat_with: 'Mengobrol dengan {name}',
  toast_load_contacts_failed: 'Gagal memuat kontak: {msg}',
  toast_load_contacts_error: 'Gagal memuat kontak. Muat ulang dan coba lagi.',
  time_just_now: 'Baru saja',
  time_minutes_ago: '{min}m lalu',
  time_hours_ago: '{hour}j lalu',
  time_days_ago: '{day}h lalu',

  // InteractionNotification.vue
  interaction_notification_title: 'Notifikasi',
  interaction_notification_subtitle: 'Komentar & Suka',
  interaction_notification_empty: 'Belum ada notifikasi',
  interaction_notification_comment: 'berkomentar: {content}',
  interaction_notification_like: 'menyukai postinganmu',
  interaction_notification_reply: 'membalas: {content}',
  interaction_notification_bookmark: 'menyimpan postinganmu',
  toast_load_notifications_failed: 'Gagal memuat notifikasi: {msg}',
  toast_load_notifications_error: 'Gagal memuat notifikasi. Muat ulang dan coba lagi.',
  mark_all_read: 'Tandai semua dibaca',
  toast_mark_all_read_failed: 'Gagal menandai semua dibaca, coba lagi',
  contacts_dnd: 'Bisukan Notifikasi',
  dnd_enabled: 'Notifikasi dibisukan',
  dnd_disabled: 'Notifikasi diaktifkan',
  dnd_action_enable: 'Bisukan Notifikasi',
  dnd_action_disable: 'Aktifkan Notifikasi',

  // Discover.vue
  toast_load_sessions_failed: 'Gagal memuat sesi: {msg}',
  toast_load_sessions_error: 'Gagal memuat sesi',
  discover_noMessages: 'Belum ada pesan',

  // EmojiInputArea.vue
  placeholder_default: 'Bagikan detail lebih dengan AI',
  userChat_typeMessage: 'Ketik pesan...',
  select_emoji: 'Pilih Emoji',
  badge_new: 'baru',
  channel_search_placeholder: 'Masukkan channel',
  channel_picker_empty: 'Masukkan channel',

  // FrontPage.vue
  tab_chat_with_ai: 'Biar OctoSay Memahamimu',
  history_chats: 'Riwayat',
  tab_connections: 'Match',
  tab_conversations: 'Pesan',
  tab_profile: 'Profil',
  new_session: 'Baru',
  history_tab_chats: 'Milikku',
  history_tab_matches: 'Match',
  channels_octosay: 'Grup Octo',
  tab_matches: 'Match',
  tab_messages: 'Pesan',

  // Header.vue
  slogan: 'OctoSay - AI yang memahamimu dan menghubungkanmu dengan orang yang tepat',
  app_name: 'OctoSay',
  slogan_short: 'AI yang memahamimu dan menghubungkanmu dengan orang yang tepat',
  slogan_ai: 'AI yang memahamimu dan menghubungkanmu dengan orang yang tepat',
  get_the_app: 'Dapatkan Aplikasi',
  desc_iphone_ipad: 'iPhone / iPad',
  desc_android: 'Android',
  search_in_app_stores: 'atau cari OctoSay di app store',

  // MapLocationPicker.vue
  placeholder_search_location: 'Cari lokasi...',
  coords_display: 'Bujur: {lng}, Lintang: {lat}',
  toast_no_geolocation: 'Peramban kamu tidak mendukung geolokasi',
  toast_location_permission_denied: 'Tidak bisa mendapatkan lokasimu, periksa izin lokasi',
  loading_address: 'Memuat alamat...',

  // MatchedSession.vue
  created_at: 'Dibuat: {time}',
  ai_match_analysis: 'Analisis Match AI',
  error_missing_session_params: 'Parameter sesi yang diperlukan tidak ada',
  match_private_hint: 'Sesi ini privat. Konten tidak tersedia',

  // PersonalCenter.vue
  label_name: 'Nama:',
  placeholder_enter_name: 'Masukkan namamu',
  label_bio: 'Bio:',
  placeholder_enter_bio: 'Tuliskan sesuatu tentang dirimu',
  placeholder_bio_empty: 'Ceritakan sesuatu tentang dirimu',
  bio: 'Bio',
  delete_account: 'Hapus Akun',
  delete_warning: 'Tindakan ini tidak dapat dibatalkan.',
  delete_data_intro: 'Data berikut akan dihapus permanen:',
  delete_item_profile: 'Informasi profilmu',
  delete_item_chat: 'Riwayat dan sesi obrolan',
  delete_item_contact: 'Informasi kontak',
  delete_item_all: 'Semua data terkait',
  final_confirmation: 'Konfirmasi Akhir',
  delete_confirm_prompt: 'Ketik "delete" untuk konfirmasi:',
  placeholder_type_delete: 'Ketik delete',
  private_token: 'Token Privat',
  token_desc: 'Buat token untuk akses API',
  toast_not_logged_in: 'Pengguna belum masuk',
  toast_name_required: 'Nama wajib diisi',
  toast_save_success: 'Berhasil disimpan',
  toast_save_failed: 'Gagal menyimpan',
  toast_image_too_large: 'Gambar melebihi batas 5MB',
  toast_avatar_updated: 'Avatar diperbarui',
  toast_avatar_failed: 'Gagal memperbarui avatar',
  toast_upload_failed: 'Gagal mengunggah',
  toast_token_generated: 'Token dibuat',
  toast_token_failed: 'Gagal membuat token',
  toast_copied: 'Tersalin ke papan klip',
  toast_copy_failed: 'Gagal menyalin',
  toast_account_deleted: 'Akun berhasil dihapus',
  toast_delete_account_failed: 'Gagal menghapus akun',
  toast_logout_success: 'Berhasil keluar',
  toast_logout_failed: 'Gagal keluar',
  profile_tab_messages: 'Pesan',
  profile_tab_comments: 'Komentar',
  profile_tab_likes: 'Suka',
  profile_tab_bookmarks: 'Tersimpan',
  profile_empty_messages: 'Belum ada pesan',
  profile_empty_comments: 'Belum ada komentar',
  profile_empty_likes: 'Belum ada suka',
  profile_empty_bookmarks: 'Belum ada yang disimpan',
  profile_reply_to: 'Membalas {name}',
  profile_stats_posts: 'Pesan',
  profile_stats_comments: 'Komentar',
  profile_stats_likes: 'Suka Diterima',
  profile_joined: 'Bergabung {date}',

  // ReportDialog.vue
  report_message_title: 'Laporkan Pesan',
  report_reason_prompt: 'Pilih alasan melaporkan pesan ini:',
  report_spam: 'Spam',
  report_harassment: 'Pelecehan atau perundungan',
  report_inappropriate: 'Konten tidak pantas',
  report_other: 'Lainnya',
  placeholder_report_desc: 'Jelaskan masalahnya (opsional)',
  toast_select_reason: 'Pilih alasan',
  toast_report_success: 'Laporan berhasil dikirim',
  toast_report_failed: 'Gagal mengirim laporan',

  // common.js
  ellipsis: '..',

  // ChatBox.vue / ChatMsgList.vue message summary prefixes
  summary_image: '[Gambar]',
  summary_images: '[Gambar x{count}]',
  summary_file: '[File]',
  summary_files: '[File x{count}]',
  summary_video: '[Video]',
  summary_videos: '[Video x{count}]',
  summary_location: '[Lokasi]',
  summary_locations: '[Lokasi x{count}]',
  summary_emoji: '[Emoji]',
  summary_emojis: '[Emoji x{count}]',
  summary_voice: '[Suara]',
  summary_voices: '[Suara x{count}]',
  summary_mixed: '[Campuran]',
  summary_other: '[Lainnya]',

  // Voice messages
  voice: 'Suara',
  voice_recording: 'Merekam...',
  toast_voice_too_short: 'Rekaman terlalu pendek',
  toast_voice_failed: 'Gagal mengirim suara',
  toast_mic_permission_denied: 'Tidak bisa mengakses mikrofon. Aktifkan di pengaturan peramban',
  toast_recording_not_supported: 'Peramban ini tidak mendukung perekaman suara',
  voice_load_failed: 'Gagal memuat pesan suara',

  // Expire At
  aiChat_expireLine: 'Berlaku hingga {date}, beri tahu AI kapan saja untuk memperbarui',
  aiChat_expireExpired: 'Konten sudah kedaluwarsa dan tidak lagi terlihat orang lain. Beri tahu AI kapan saja untuk memperbarui masa berlaku',

  // MatchedSession.vue
  detail: 'Detail',

  // Match notification hints
  match_new_result_hint: 'Jika ada hasil match baru, kamu akan diberi tahu. Untuk pengalaman lebih baik, pasang aplikasinya agar menerima notifikasi seketika.',

  // Match notification hints
  match_connection_notify_hint: 'Match dibuat dan diberi tahu! Segera sapa dia!',
  match_continuousMatching: 'AI terus mencarikan match untukmu',
  match_continuousMatchingHint: 'Kami akan memberitahumu begitu ada match baru',
  match_continuousMatchingOthers: 'AI terus mencarikan match untuknya',
  match_continuousMatchingOthersHint: 'Match baru akan muncul di sini saat ditemukan',
  match_noResultsTitleOthers: 'Masih mencarikan match untuknya',
  match_noResultsHintOthers: 'AI terus mencarikan match untuknya. Hasil akan muncul di sini begitu ditemukan.',
  match_newMatchFound: '{n} match baru ditemukan!',
  match_worth_exploring_hint: 'Kamu yang memutuskan untuk menghubungi atau tidak.',

  // Matches filter tags
  filter_all: 'Semua',
  filter_best_connection: 'Match Terbaik',
  filter_worth_a_look: 'Layak Dilihat',

  // LandingPage.vue (CN Portal)
  landing_brand_slogan: 'OctoSay - AI yang memahamimu dan menghubungkanmu dengan orang yang tepat',
  landing_hero_title: 'Tulis di hub-mu — AI memperjelas dulu, lalu kamu publikasikan dan dapat match.',
  landing_hero_subtitle: 'Ketik pesan yang ingin kamu bagikan di Grup Octo. Sebelum tayang, AI akan mengobrol dulu untuk memastikan detailnya. Setelah kamu konfirmasi, pesan dan ringkasan AI diposting bersamaan, dan AI mulai mencocokkan.',
  landing_download_on: 'Unduh di',
  landing_get_it_on: 'Dapatkan di',
  landing_direct_download: 'Unduhan Langsung',
  landing_how_title: 'Cara Kerjanya',
  landing_step1_title: 'Tulis di Grup',
  landing_step1_desc: 'Ketik pesan yang ingin kamu bagikan di hub. AI akan mengobrol dulu dengammu untuk memperjelas detailnya, sehingga setiap postingan jelas, berguna, dan siap dipasangkan — tidak hilang di antara keramaian.',
  landing_step2_title: 'Konfirmasi, Posting & Dapatkan Match',
  landing_step2_desc: 'Saat kamu mengonfirmasi, pesan aslimu dan ringkasan AI diposting bersamaan ke hub. Setelah itu AI terus mencari match terbaikmu, jadi pesanmu tidak tenggelam atau diabaikan.',
  landing_step3_title: 'Terhubung & Mengobrol',
  landing_step3_desc: 'Saat match ditemukan, kedua pihak bisa melihat riwayat obrolan masing-masing dengan AI dan ringkasan AI. Dengan konteks yang sama, memulai percakapan jadi mudah — tinggal mengobrol santai.',
  // Comparison Section
  landing_comparison_title: 'Kenapa OctoSay?',
  landing_comparison_subtitle: 'Obrolan hub, tapi AI memperjelas detail dan aktif mencocokkanmu.',
  landing_comparison_other: 'Discord',
  landing_comparison_octo: 'OctoSay',
  landing_cmp1_label: 'Kualitas Konten',
  landing_cmp1_other: 'Spam, iklan, dan obrolan melebar ke mana-mana',
  landing_cmp1_octo: 'Hanya kartu kebutuhan pilihan AI',
  landing_cmp2_label: 'Mencari Orang',
  landing_cmp2_other: 'Posting lalu menunggu balasan',
  landing_cmp2_octo: 'AI aktif mencocokkanmu',
  landing_cmp3_label: 'Tingkat Kebisingan',
  landing_cmp3_other: 'Ratusan pesan untuk digulir',
  landing_cmp3_octo: 'Nol kebisingan, setiap postingan berarti',
  landing_cmp4_label: 'Memulai',
  landing_cmp4_other: 'Cari server, jelajahi channel, pelajari sendiri',
  landing_cmp4_octo: 'Ketik di hub; AI memperjelas dan mencocokkan',
  landing_cmp_other_wechat: 'WeChat',
  landing_cmp_other_xhs: 'Xiaohongshu',
  landing_cmp_other_facebook: 'Facebook',
  landing_cmp_other_reddit: 'Reddit',
  landing_cmp1_wechat: 'Obrolan grup banjir iklan & spam',
  landing_cmp1_xhs: 'Postingan promosi di mana-mana, sulit dipercaya',
  landing_cmp1_facebook: 'Iklan dan clickbait memenuhi feed',
  landing_cmp1_reddit: 'Spam dan postingan melebar ke mana-mana',
  landing_cmp2_wechat: 'Hanya lewat kontak dan undangan grup',
  landing_cmp2_xhs: 'Cari sendiri dan gali postingan',
  landing_cmp2_facebook: 'Terbatas pada teman & grup yang sudah ada',
  landing_cmp2_reddit: 'Jelajahi subreddit sendiri, berharap ada balasan',
  landing_cmp3_wechat: 'Menggulir ratusan pesan grup',
  landing_cmp3_xhs: 'Feed penuh rekomendasi dan iklan',
  landing_cmp3_facebook: 'Postingan rekomendasi & iklan tanpa akhir',
  landing_cmp3_reddit: 'Ratusan komentar untuk digulir',
  landing_cmp5_label: 'Siapa yang Mencari',
  landing_cmp5_wechat: 'Tanya satu per satu, berharap beruntung',
  landing_cmp5_xhs: 'Posting, tunggu komentar, saring sendiri',
  landing_cmp5_facebook: 'Harus bertanya ke sana ke Meri di grup',
  landing_cmp5_reddit: 'Posting, tunggu balasan, lalu saring',
  landing_cmp5_octo: 'AI terus mencarikan orang untukmu, otomatis',

  landing_features_title: 'Fitur Utama',
  landing_feature1_title: 'Perjelas Sebelum Posting',
  landing_feature1_desc: 'Tidak perlu mengisi formulir. Ketik pesanmu di hub dan AI akan mengobrol dulu untuk menanyakan hal yang tepat dan benar-benar memahami kebutuhanmu.',
  landing_feature2_title: 'Bersih, Tidak Berantakan',
  landing_feature2_desc: 'Pesan dan ringkasan AI diposting bersamaan — OctoSay mengurasi setiap postingan, jadi tidak ada spam, tidak ada obrolan melebar, tidak ada kebisingan yang harus digulir.',
  landing_feature3_title: 'Matching Proaktif',
  landing_feature3_desc: 'Setelah kamu konfirmasi dan pesan + ringkasan AI tayang, AI terus memindai hub untuk menemukan orang yang sesuai dengan yang kamu cari — dan menjelaskan alasannya.',
  landing_feature4_title: 'Komunitas Topik, Nol Kebisingan',
  landing_feature4_desc: 'Gabung ke hub topik — olahraga, game, tukar bahasa, teman satu kos — AI memperjelas pesanmu sebelum posting, jadi setiap hub tetap bersih dan berguna.',
  landing_feature5_title: 'Privasi Terlindungi',
  landing_feature5_desc: 'Kamu bisa menjadikan pesan privat setelah dikirim, hanya terlihat olehmu. Kendali penuh.',
  landing_feature6_title: 'Percakapan yang Bermakna',
  landing_feature6_desc: 'Tanpa kebisingan, tanpa gangguan — setiap pesan berarti.',
  landing_usecases_title: 'Berlaku untuk Skenario Apa Pun',
  landing_usecases_subtitle: 'Apa pun yang ada di pikiranmu, gabung ke hub topik — AI urus mencocokkannya supaya kamu tak perlu menggulir dan mencari',
  landing_usecase_game: 'Teman Main Game',
  landing_usecase_language: 'Tukar Bahasa',
  landing_usecase_skill: 'Tukar Keahlian',
  landing_usecase_roommate: 'Cari Teman Sekamar',
  landing_usecase_travel: 'Teman Jalan',
  landing_usecase_sports: 'Partner Olahraga',
  landing_usecase_study: 'Partner Belajar',
  landing_usecase_anything: '...atau bagikan apa saja',
  landing_cta_title: 'Siap Memulai?',
  landing_cta_desc: 'Gabung ke hub topik, tulis apa yang ingin dibagikan, biarkan AI memperjelas detailnya, lalu publikasikan dan dapat match dengan orang yang tepat.',
  landing_use_now: 'Pakai Sekarang',
  landing_groups: 'Grup',

  // OnboardingPage.vue
  onboarding_skip: 'Lewati',
  onboarding_next: 'Lanjut',
  onboarding_getStarted: 'Mulai',
  onboarding_step1Title: "Katakan kebutuhanmu di hub",
  onboarding_step1Desc: "Apa pun yang kamu cari atau ingin lakukan, tinggal katakan saja. AI akan mengobrol untuk memperjelas detailnya dan mengubahnya menjadi kebutuhan yang jelas.",
  onboarding_step2Title: 'Konfirmasi, Posting & Dapatkan Match',
  onboarding_step2Desc: "Saat pesanmu diposting ke hub, AI akan terus mencari match terbaikmu, jadi pesanmu tidak tenggelam atau diabaikan.",
  onboarding_step3Title: 'Terhubung & Mengobrol',
  onboarding_step3Desc: "Kedua pihak bisa melihat obrolan masing-masing dengan AI dan tahu apa yang dicari. Dengan konteks yang sama, memulai percakapan jadi mudah — tinggal mengobrol santai.",

  // ChannelDetail.vue
  channel_image_limit: 'Maksimal 1 gambar',

  // ChannelMembers.vue
  channel_members_empty: 'Belum ada anggota',
  channel_members_title: 'Anggota',
  channel_role_owner: 'Pemilik',
  channel_role_admin: 'Admin',
  channel_role_member: 'Anggota',

  // Settings.vue
  settings_language: 'Bahasa',
  settings_language_followSystem: 'Ikuti Sistem',

  // ChatBox.vue
  match_interested_suffix: ', {count} layak dilihat',

  // ChatBox.vue - Tahapan progres pencocokan AI
  match_stage_fetch_chat: 'Mengambil percakapan',
  match_stage_query_expansion: 'Memperluas kueri',
  match_stage_semantic_search: 'Pencarian semantik',
  match_stage_deep_search: 'Analisis mendalam',
  match_stage_rerank: 'Pencocokan cerdas',
  match_stage_refining: 'Menyempurnakan hasil',
  match_stage_fetch_details: 'Mengambil detail',

  // ChannelDetail.vue - Unggah gambar
  channel_select_image: 'Silakan pilih file gambar',
  channel_image_upload_failed: 'Gagal mengunggah gambar, coba lagi',
  chatInput_channelSearchHint: "Cari grup",
}



// WEBPACK FOOTER //
// ./src/i18n/id.js